var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNumberedPin1 = function SvgNumberedPin1(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15517_10468)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_15517_10468)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.25,
    cy: 29,
    rx: 4,
    ry: 2,
    fill: "black",
    fillOpacity: 0.12
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_15517_10468",
    maskUnits: "userSpaceOnUse",
    x: 1.25,
    y: 1,
    width: 22,
    height: 28,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 1.25,
    y: 1,
    width: 22,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1659 20.0632C20.6426 18.243 22.25 15.3092 22.25 12C22.25 6.47715 17.7728 2 12.25 2C6.72715 2 2.25 6.47715 2.25 12C2.25 15.3092 3.85742 18.243 6.33406 20.0632C8.21608 21.4813 10.869 23.7185 11.4788 27.3195C11.5434 27.701 11.8631 27.997 12.25 27.997C12.6369 27.997 12.9566 27.701 13.0212 27.3195C13.631 23.7185 16.2839 21.4813 18.1659 20.0632Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1659 20.0632C20.6426 18.243 22.25 15.3092 22.25 12C22.25 6.47715 17.7728 2 12.25 2C6.72715 2 2.25 6.47715 2.25 12C2.25 15.3092 3.85742 18.243 6.33406 20.0632C8.21608 21.4813 10.869 23.7185 11.4788 27.3195C11.5434 27.701 11.8631 27.997 12.25 27.997C12.6369 27.997 12.9566 27.701 13.0212 27.3195C13.631 23.7185 16.2839 21.4813 18.1659 20.0632Z",
    fill: "#E81A3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1659 20.0632L17.5737 19.2573L17.5641 19.2645L18.1659 20.0632ZM6.33406 20.0632L6.9359 19.2645L6.92626 19.2574L6.33406 20.0632ZM11.4788 27.3195L10.4928 27.4865H10.4928L11.4788 27.3195ZM13.0212 27.3195L14.0072 27.4865H14.0072L13.0212 27.3195ZM18.7581 20.869C21.4801 18.8685 23.25 15.6409 23.25 12H21.25C21.25 14.9776 19.805 17.6175 17.5737 19.2574L18.7581 20.869ZM23.25 12C23.25 5.92487 18.3251 1 12.25 1V3C17.2206 3 21.25 7.02944 21.25 12H23.25ZM12.25 1C6.17487 1 1.25 5.92487 1.25 12H3.25C3.25 7.02944 7.27944 3 12.25 3V1ZM1.25 12C1.25 15.6409 3.01987 18.8685 5.74185 20.869L6.92626 19.2574C4.69496 17.6175 3.25 14.9776 3.25 12H1.25ZM12.4647 27.1526C11.7845 23.1359 8.83192 20.6933 6.93585 19.2645L5.73226 20.8618C7.60024 22.2694 9.95338 24.3011 10.4928 27.4865L12.4647 27.1526ZM12.25 26.997C12.3186 26.997 12.3751 27.0246 12.4093 27.0551C12.4412 27.0836 12.4589 27.118 12.4647 27.1526L10.4928 27.4865C10.6309 28.3017 11.3289 28.997 12.25 28.997V26.997ZM12.0353 27.1526C12.0411 27.118 12.0588 27.0836 12.0907 27.0551C12.1249 27.0246 12.1814 26.997 12.25 26.997V28.997C13.1711 28.997 13.8691 28.3017 14.0072 27.4865L12.0353 27.1526ZM17.5641 19.2645C15.6681 20.6933 12.7155 23.1359 12.0353 27.1526L14.0072 27.4865C14.5466 24.3011 16.8998 22.2694 18.7677 20.8618L17.5641 19.2645Z",
    fill: "white",
    mask: "url(#path-2-outside-1_15517_10468)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5039 7.45117V16H11.8164V9.39648L9.78906 10.041V8.71094L13.3223 7.45117H13.5039Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_15517_10468",
    x: 6.25,
    y: 25,
    width: 12,
    height: 8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_15517_10468"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15517_10468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 32,
    fill: "white",
    transform: "translate(0.25)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNumberedPin1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/numbered-pin-1.2e7c80e83a869cd20bffe432ed1224af.svg";